module.exports = __webpack_public_path__ + "static/media/nu.bfd6de48.svg";